import { Injectable } from '@angular/core';
import { AuthentService } from './authent.service';

declare const globalConfig: any;

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
  ) { }

  getGipServicesUrl() {
    var url: string = globalConfig['GipServicesUrl'];
    if(window.location.protocol == "https:"){
      url = url.replace("http:/", "https:/")
    }
    return url;
  }

  async getPicklist(urls: string[], CallbackFunction) {
    const responses = await Promise.all(urls.map(url => fetch(this.getGipServicesUrl() + url)));

    const results = new Array();

    for (const res of responses) {
      const data = await res.json();
      results.push(data);
    }

    CallbackFunction(results);
  }

    async getData(urls: string[], CallbackFunction) {
    const responses = await Promise.all(urls.map(url => fetch(this.getGipServicesUrl() + url)));

    const results = new Array();

    for (const res of responses) {
      const data = await res.json();
      results.push(data.value);
    }

    CallbackFunction(results);
  }

  async getAuthData(urls: string[], CallbackFunction) {
    const responses = await Promise.all(urls.map(url => fetch(this.getGipServicesUrl() + url)));

    const results = new Array();

    for (const res of responses) {
      const data = await res.json();
      results.push(data.value);
    }

    CallbackFunction(results);
  }
}
